import React, { Component }  from 'react'
import { NavigationHeader, Div, Breadcrumbs } from '@driftt/tide-core'
import QueryString from 'qs'
import MarketoImportEventLogs from 'components/Imports/ImportLogs/MarketoImportEventLogs'

import './style.css'

const ImportBreadcrumb = () => (
  <Breadcrumbs 
    className="secondary-heading-breadcrumb" 
    headings={[
      {title: 'Contact imports', link: '/contacts/imports'},
      {title: 'Logs', link: '/contacts/imports/logs'}
    ]}
  />
)

class MarketoImport extends Component {
  render() {
    const parsedQueryString = QueryString.parse(this.props.location.search, { ignoreQueryPrefix: true })
    const segmentTitle = parsedQueryString.title
    const pageTitle = `Marketo Import Logs ${segmentTitle ? '—' : ''} ${segmentTitle || ''}`

    return (
      <Div className="imports--page-container">
        <NavigationHeader title={pageTitle} secondary={ImportBreadcrumb} />
        <MarketoImportEventLogs {...this.props} />
      </Div>
    )
  }
}

export default MarketoImport
